import { create } from "zustand"

interface AllQuestsModalStore {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

export const useAllQuestsModalStore = create<AllQuestsModalStore>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}))
